const Fields = [
    {
        name: "name",
        label: "Name",
        type: "text",
        editable: true,
        validation: [
            { type: "required", errMsg: "Name Field is required" }
        ]
    },
    {
        name: "value",
        label: "Value",
        type: "text",
        editable: true,
        validation: [
            { type: "required",errMsg: "Value is required" }
        ]
    },
    {
        //Note: optional on purpose. Initiators created before tag_type existed
        //carry no value, and the tag template wizard keeps showing unclassified
        //initiators for both structures rather than hiding them.
        name: "tag_type",
        label: "Tag Type",
        type: "select",
        editable: true,
        options: [
            { label: "Not set", value: "" },
            { label: "Container", value: "container" },
            { label: "Atomic", value: "atomic" }
        ],
        helpText: "Whether this initiator is used for container tags or atomic tags. "
            + "Leave unset if it applies to both."
    },
    {
        name: "url",
        label: "URL",
        type: "text",
        editable: true,
        validation: [
            { type: "url", base:''}
        ]
    },
    {
        name: "description",
        label: "Description",
        type: "text",
        editable: true,
    },
    {
        name: "logo",
        label: "Logo",
        type: "image",
        editable: true,
        maxSize: 60,// maximum size in KB,
        format: 'png',
        helpText: "PNG only, max 60 KB. Horizontal (landscape) logos are supported and recommended &mdash; "
            + "around 240&times;80 px, with a transparent background. "
    }
];

export default Fields;